<!-- ngIf below is not to print copy before processing is triggered (its ng-cloak thing) -->
<div class="wrap-x wrap-l center">
    <div class="w-12-s"
         [ngClass]="[component.component_width === 'fixed' ? 'w-10' : 'w-12']">
        <div class="flex flex-column-reverse-s"
             [ngClass]="('flex-' + component.vertical_text_align)">

            <!-- image XLM -->
            <div [sizeClass]="'XLM:flex-span-1, S:w-12'">
                @if (component.image) {
                <href [link]="component.url">
                    <img class="w-12"
                         [dfImage]="component.image"
                         [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                         [ratio]="component.image_ratio">
                </href>
                }
            </div>

            <!-- text -->
            <div class="w-12"
                 [ngClass]="component.horizontal_text_align"
                 [sizeClass]="'!S:flex-span-1 p-a'">

                <!-- title -->
                <h1 class="m-t m-b m-t-7-s m-b-7-s p-l-4-s p-r-4-s w-9"
                    [ngClass]="component.title_style"
                    *iCms="'title' of component; skipEmpty: true"></h1>

                <!-- copy -->
                <href [link]="component.url">
                    <div class="text m-t m-t-0-s p-a-4-s"
                         [ngClass]="component.copy_style"
                         *iCms="'copy' of component; content: 'html'">
                    </div>
                </href>
            </div>
        </div>
    </div>
</div>